import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container footer">
        <h1 className="footer__title">Kapil</h1>
        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>
          <li>
            <a href="#services" className="footer__link">
              Services
            </a>
          </li>
          <li>
            <a href="#skills" className="footer__link">
              Skills
            </a>
          </li>
        </ul>

        <div className="footer__social">
          <a
            href="https://www.linkedin.com/in/kapil-gahlot-b4b29121a/"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
          >
            <i class="bx bxl-linkedin"></i>
          </a>
          <a
            href="https://www.instagram.com/thesmartcoders"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
          >
            <i class="bx bxl-instagram"></i>
          </a>
          <a
            href="https://github.com/kapilgahlot1998"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
          >
            <i class="bx bxl-github"></i>
          </a>
          <a
            href="https://stackoverflow.com/users/16796135/kapilgahlot"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
          >
            <i class='bx bxl-stack-overflow' ></i>
          </a>
          <a
            href="https://leetcode.com/KapilGahlot/"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
          >
            <i class="bx bx-code"></i>
          </a>
        </div>
        <span className="footer__copy">
          &#169; TheSmartCoder. All rights reserved{' '}
        </span>
      </div>
    </footer>
  )
}

export default Footer
